import script from "./EntityFieldRow.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityFieldRow.vue?vue&type=script&setup=true&lang=js"

import "./EntityFieldRow.vue?vue&type=style&index=0&id=52c42694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c42694"]])

export default __exports__